// @flow
import type { Element } from 'React';

import React from 'react';
import FormGroup from '../EnhancedFormGroup/index.js';

type Props = {};
/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
const Fieldset = ({ ...rest }: Props): Element<typeof FormGroup> => (
  <FormGroup {...rest} tag="fieldset" />
);

export default Fieldset;
